import { render, staticRenderFns } from "./courseProjectsMangeTeacher.vue?vue&type=template&id=8bfa1af4&scoped=true"
import script from "./courseProjectsMangeTeacher.vue?vue&type=script&lang=js"
export * from "./courseProjectsMangeTeacher.vue?vue&type=script&lang=js"
import style0 from "./courseProjectsMangeTeacher.vue?vue&type=style&index=0&id=8bfa1af4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfa1af4",
  null
  
)

export default component.exports